module.exports = __webpack_public_path__ + "img/ESCUT_1930.19f0fe65.jpg";